 <div class="fc-input-template"><ng-template fcInputHost></ng-template></div>
 <div class="fc-input-actions" *ngIf="templateName" >
    <button class="btn btn-update-results" (click)="onUpdateResults();">Update Results</button>
    <button class="btn btn-more-options" (click)="onToggleRefine()" *ngIf="!showVertical">
        <span *ngIf="!showAllOptions">More Options <i class="btn-options-down"></i></span>
        <span *ngIf="showAllOptions">Less Options <i class="btn-options-up"></i></span>
    </button>
 </div>